import { Modal } from '@/shared/ui';

import CopaysMedicineImg from '@/assets/images/onboarding/copays-medicine.png';

interface IProps {
    open: boolean;
    onClose(): void;
};

const CopaysQuestions = ({ open, onClose }: IProps) => (
    <Modal
        open={open}
        onClose={onClose}
        contentClassName="sm:max-w-[511px] md:!py-[50px] py-[30px] px-[20px] md:px-[40px]"
        defaultContentSizes={false}
    >
        <div className="items-centers flex flex-col">
            <img src={CopaysMedicineImg} alt="" className="mx-auto" />
            <h3 className="mx-auto mb-[0.625rem] max-w-[313px] text-center font-agrandir text-3xl">Have questions about your copays?</h3>
            <div className="flex flex-col px-[7px] sm:px-0">
                <p className="text-center font-atkinsonHyperlegible text-[15px] sm:text-lg mb-[0.625rem]">
                    Did You know that your copay amount is determined by your insurance plan Not the Pharmacy.
                </p>

                <span className="pb-[0.625rem] text-center font-atkinsonBold text-[17px] sm:text-lg">Why we ask for payment method</span>

                <p className="text-center font-atkinsonHyperlegible text-[15px] sm:text-lg">
                    Saving a card allows for fast, hassle-free monthly payments for copays and OTC items, ensuring timely medication refill and delivery.
                </p>
            </div>
        </div>
    </Modal>
);

export default CopaysQuestions;